module.exports = __webpack_public_path__ + "img/fail.f26a37a2.svg";